<template>
  <div class="search-nav-start-end flex gap-2 w-full xl:w-auto">
    <div class="title">
      <vs-select class="w-full" autocomplete v-model="label" @change="onChangeData" :disabled="readonly">
        <vs-select-item v-for="(label, index) in labels" :key="index" :text="label" :value="label" />
      </vs-select>
    </div>
    <div class="flex-1 flex flex-wrap items-center gap-2">
      <date-selector v-model="sDate" :readonly="readonly" placeholder="선택" @change="onChangeData" class="w-full xl:w-32" />
      <span>~</span>
      <date-selector v-model="eDate" :readonly="readonly" placeholder="선택" @change="onChangeData" class="flex-1 xl:w-32" />
    </div>
  </div>
</template>

<script>
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
export default {
  name: "SearchNavStartEnd",
  components: {
    DateSelector,
    SearchNavItemSelect,
  },
  props: {
    labels: {
      default: ["작성일"],
      type: Array,
    },
    value: Object | String,
    readonly: Boolean,
  },
  watch: {
    value(value) {
      const { label, sDate, eDate } = value;
      this.label = label;
      this.sDate = sDate;
      this.eDate = eDate;
    },
  },
  data() {
    return {
      label: this.labels[0],
      sDate: "",
      eDate: "",
    };
  },
  mounted() {
    if (!this.value || !this.value.sDate) {
      this.$emit("input", { label: this.label, sDate: this.sDate, eDate: this.eDate });
    }
  },
  methods: {
    onChangeData() {
      this.$emit("input", { label: this.label, sDate: this.sDate, eDate: this.eDate });
      this.$emit("change", { label: this.label, sDate: this.sDate, eDate: this.eDate });
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  width: 114px;

  font-weight: 500;
  line-height: 38px;
  text-align: left;
  white-space: nowrap;
}
</style>
